import { render, staticRenderFns } from "./RatingTypeShow.vue?vue&type=template&id=571b6476&"
import script from "./RatingTypeShow.vue?vue&type=script&lang=js&"
export * from "./RatingTypeShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports